import React from 'react';
import { Box, CircularProgress, ImageListItem, Paper, Tooltip, useTheme } from '@mui/material';
// Types
import type { ImageGroupItemProps } from '50.quickConnect.Fields/FieldsTypes/Containers/ImagesGroupQcField/components/ImageGroupItem/types';

// Business
import useData from '50.quickConnect.Fields/FieldsTypes/Containers/ImagesGroupQcField/components/ImageGroupItem/hooks';
import {
  StyledBadge,
  StyledNoPhotoIcon,
} from '50.quickConnect.Fields/FieldsTypes/Containers/ImagesGroupQcField/components/ImageGroupItem/styles';

export default function ImageGroupItem({ fieldId, url, labelClass, fullPathId }: ImageGroupItemProps) {
  const theme = useTheme();

  const {
    srcSet,
    isChecked,
    handleClick,
    isMandatory,
    isVisible,
    handleImgSrcOnError,
    fallbackImg,
    label,
    recordedItems,
    visible,
    mandatoryFilled,
    labelClass: itemLabelClass,
  } = useData(url, fieldId);

  if (visible === false || !isVisible) return <></>;

  const effectiveClass = itemLabelClass || labelClass;

  // Extract text content from HTML label
  const tooltipLabel = label?.replace(/(<([^>]+)>)/gi, '') ?? '';

  return (
    <Paper
      className={effectiveClass}
      id={`scrollToAnchor-${fullPathId}`}
      elevation={2}
      sx={{
        border: isChecked() ? `4px solid ${theme.palette.primary.main}` : 'unset',
        position: 'relative',
        borderRadius: '10px',
        aspectRatio: 1,
        cursor: 'pointer',
      }}
    >
      {isMandatory && (
        <span
          data-cy={`mandatory-star${typeof fieldId === 'string' ? fieldId : ''}${mandatoryFilled ? '' : 'error'}`}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            color: mandatoryFilled ? theme.palette.text.disabled : theme.palette.error.main,
            fontWeight: 'bolder',
          }}
        >
          *
        </span>
      )}

      <Box onClick={handleClick}>
        {srcSet.length > 0 ? (
          <Tooltip title={tooltipLabel}>
            <ImageListItem
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <StyledBadge badgeContent={recordedItems} color="primary">
                {fallbackImg ? (
                  <StyledNoPhotoIcon />
                ) : (
                  <img
                    src={srcSet}
                    onError={handleImgSrcOnError}
                    alt={typeof fieldId === 'string' ? fieldId : 'unknown alt'}
                    style={{
                      width: '125px',
                      height: '125px',
                      objectFit: 'contain',
                    }}
                  />
                )}
              </StyledBadge>
            </ImageListItem>
          </Tooltip>
        ) : (
          <CircularProgress />
        )}
      </Box>
    </Paper>
  );
}
